module.exports = __webpack_public_path__ + "assets/img/tiyancard.77d98890.png";